/**
 * Release configuration for Nexus app downloads
 * This file is automatically updated by GitHub Actions when new releases are published
 * Last updated: 2025-12-11 20:12:32 UTC
 */

export const RELEASES = {
  latest: {
    version: '1.0.1',
    tagName: 'v1.0.1',
    // Primary download URL (S3)
    downloadUrl: 'https://mscontrol-ios-app.s3.amazonaws.com/releases/Bento-1.0.1.dmg',
    // GitHub release URL (fallback)
    githubUrl: 'https://github.com/mscontrol-ai/nexus/releases/download/v1.0.1/Bento-1.0.1.dmg',
    // Release page for full details
    releaseNotesUrl: 'https://github.com/mscontrol-ai/nexus/releases/tag/v1.0.1',
  }
} as const;
